module.exports = __webpack_public_path__ + "img/VLERICK.a7b88e88.jpg";